export const gu = {
    "TRIGGER_LISTEN": "ટ્રિગર માટે સાંભળી રહ્યા છે,",
    "ASSIST_EMPTY_MSG": "એજન્ટ એઆઇ તમારી વાતચીતને સક્રિય રીતે સાંભળી રહી છે અને ટ્રિગર થતી વખતે આપમેળે મદદ કરવા તૈયાર છે.",
    "MYBOT_TRIGGET_LISTEN": "આ વખતે કોઈ સક્રિય મારો બોટ કાર્ય નથી.",
    "MYBOT_EMTPY_MSG": "મારો બોટ પર કાર્ય શરૂ કરવા માટે, શોધ ટેબ પર જાઓ અને તમારી ઈચ્છિત કાર્ય માટે \"\"એજન્ટ ઇનપુટ્સ સાથે ચલાવો\"\" વિકલ્પ પસંદ કરો.",
    "PROACTIVE_MODE": "પ્રોએક્ટિવ મોડ,",
    "SETTINGS": "સેટિંગ્સ,",
    "HELP_AND_SUPPORT": "મદદ અને સમર્થન,",
    "HELP": "મદદ,",
    "LANGUAGE": "ભાષા,",
    "THEME": "થિમ,",
    "AUTO_SCROLL_TOOLTIP":"અસિસ્ટ ટૅબ, મારો બોટ અને ટ્રાન્સક્રિપ્ટ ટૅબ સામગ્રીનું સ્વચાલિત સ્ક્રોલિંગ નિયંત્રિત કરે છે",
    "AUTOMATIC": "ઓટોમેટિક,",
    "DARK": "ડાર્ક,",
    "LIGHT": "લાઇટ,",
    "FILE_NAME":"ફાઇલનું નામ",
    "THEME_DESC": "આ તમારા સિસ્ટમ ડિફોલ્ટ મોડનો ઉપયોગ કરશે,",
    "DOCUMENTATION": "દસ્તાવેજીકરણ,",
    "DOC_DESC": "અમારા વિસ્તૃત દસ્તાવેજીકરણ લેખો તપાસો.",
    "FAQ_U": "વારંવાર પૂછાતા પ્રશ્નો,",
    "FAQ_DESC": "એજન્ટ એઆઇ વિશે વારંવાર પૂછાતા પ્રશ્નો તપાસો.",
    "KORE_ACADEMY": "કોર એકેડમી,",
    "KORE_ACA_DESC": "એકેડમી કોર્સમાં જઈને એજન્ટ એઆઇ વિશે વધુ જાણો.",
    "SEARCH": "શોધો,",
    "MY_BOT": "મારો બોટ,",
    "TAB_TEXT":"કોઈ ટૅબ સક્રિય નથી! કૃપા કરીને ઓછામાં ઓછી એક ટૅબ સક્રિય કરો",
    "ASSIST": "મદદ,",
    "TRANSCRIPT": "ટ્રાન્સક્રિપ્ટ,",
    "HISTORY": "ઇતિહાસ,",
    "STARTOVER": "ફરીથી શરૂ કરો,",
    "RESTART_INPUTS": "કૅપ્ચર કરેલ ઇનપુટ્સ સાથે ફરીથી શરૂ કરો,",
    "ASKCUSTOMER": "ગ્રાહકને પૂછો,",
    "TELLCUSTOMER": "ગ્રાહકને કહો,",
    "TAP_SEARCH":"શોધ માટે ટેપ કરો",
    "WELCOME_MSG": "સ્વાગત સંદેશ,",
    "SEND": "મોકલો,",
    "SENT": "મોકલવામાં આવ્યું,",
    "AWAITING": "પ્રતિસાદની રાહ જોવી | આગળ વધવા માટે ટાઇપ કરો,",
    "OVERRIDE": "આગળ વધવા માટે ટાઇપ કરો,",
    "OVERRIDE_FILE": "આગળ વધવા માટે ફાઇલ જોડો,",
    "ACCEPT_RESPONSE": "પ્રતિસાદ સ્વીકાર્યો,",
    "AGENT_ENTERED": "એજન્ટ પ્રવેશ્યું,",
    "EXPECTED_FORMAT": "આશાનકિત સ્વરૂપ,",
    "INPUT_VALUES": "ઇનપુટ મૂલ્યો,",
    "RESTART": "ફરીથી શરૂ કરો,",
    "START_OVER": "ફરીથી શરૂ કરો,",
    "RESTART_CAPTURE": "કૅપ્ચર કરેલ ઇનપુટ્સ સાથે ફરીથી શરૂ કરો,",
    "CANCEL": "રદ્દ કરો,",
    "INTERRUPT_DIALOG": "વિક્ષેપિત ડાયલોગ કાર્ય,",
    "RUN": "ચાલાવો,",
    "RUN_AGENT": "એજન્ટના ઇનપુટ સાથે ચલાવો,",
    "STEP": "પગલું,",
    "DIALOG_TASK": "ડાયલોગ કાર્ય,",
    "FAQ": "વારંવાર પૂછાતા પ્રશ્નો,",
    "SNIPPET": "જવાબો,",
    "ARTICLE": "વેબ પૃષ્ઠો,",
    "FILE": "ફાઇલો,",
    "SUGGESTED": "સૂચવેલ,",
    "ALL_DIALOG": "તમામ ડાયલોગ કાર્યો,",
    "DIALOG_TEXT": "ડાયલોગ,",
    "INTENT_IDENTIFIED": "ગ્રાહક ઉચારો,",
    "NOT_WHAT_LOOKING": "ખોટી સૂચન?",
    "BOT": "બોટ,",
    "CUSTOMER": "ગ્રાહક,",
    "PLAYBOOK": "પ્લેબુક",
    "YOU": "તમે,",
    "TERMINATE_CONV": "ડાયલોગ કાર્ય સમાપ્ત કરો,",
    "TERMINATE_CONV_DESC": "શું તમે ખરેખર ડાયલોગ કાર્ય સમાપ્ત કરવા માંગો છો? એજન્ટ એઆઇ હવે સૂચનો આપી શકશે નહીં.",
    "YES_TERMINATE": "હા, સમાપ્ત કરો,",
    "NO_CANCEL": "ના, રદ્દ કરો,",
    "OVERRIDE_CONTINUE": "ઓવરરાઈડ મોડ સાથે ચાલુ રાખો,",
    "SUMMARY_TEXT": "સારાંશ,",
    "SUBMIT": "સબમિટ કરો,",
    "INTERRUPT_OCCURED": "વિક્ષેપ થયો,",
    "IDENTIFIED_INTENT": "ઓળખાયેલ ઈરાદો,",
    "INTERRUPT_DESC": "આ ચલાવવાથી તમારી ચાલુ ડાયલોગ કાર્ય સમાપ્ત થઈ જશે.",
    "ACCEPT_RUN": "સ્વીકારો અને ચલાવો,",
    "RUN_LATER": "પછી ચલાવો,",
    "KNOW_MORE": "વધુ જાણો,",
    "MORE_TEXT": "વધુ,",
    "LESS_TEXT": "ઓછું,",
    "VIEW_MORE": "વધુ જુઓ,",
    "VIEW_LESS": "ઓછું જુઓ,",
    "SHOW_MORE_FAQ": "વધુ વારંવાર પૂછાતા પ્રશ્નો બતાવો,",
    "SHOW_LESS_FAQ": "ઓછું વારંવાર પૂછાતા પ્રશ્નો બતાવો,",
    "SHOW_MORE_ARTICLE": "વધુ વેબ પૃષ્ઠો બતાવો,",
    "SHOW_LESS_ARTICLE": "ઓછું વેબ પૃષ્ઠો બતાવો,",
    "SHOW_MORE_SNIPPET": "વધુ જવાબો બતાવો,",
    "SHOW_LESS_SNIPPET": "ઓછું જવાબો બતાવો,",
    "SHOW_MORE_FILES": "વધુ ફાઇલો બતાવો,",
    "SHOW_LESS_FILES": "ઓછું ફાઇલો બતાવો,",
    "VIEW_ALL_DIALOG": "તમામ ડાયલોગ જુઓ,",
    "VIEW_FEW_DIALOG": "ઓછું ડાયલોગ જુઓ,",
    "HELP_FULL": "ઉપયોગી?",
    "THANKYOU": "આભાર!",
    "EXPAND_MORE": "વિસ્તાર / વધુ,",
    "CLOSE_TEXT": "બંધ કરો,",
    "STARTED": "શરૂ થયું,",
    "ENDED": "સમાપ્ત થયું,",
    "VIEW_FULL_ARTICLE": "વેબ પૃષ્ઠ જુઓ,",
    "VIEW_FULL_FILE": "ફાઇલ જુઓ,",
    "COPIED": "કોપી કરેલ,",
    "SENTI_ANALY": "ભાવના વિશ્લેષણ,",
    "WRONG_SUGGESTION": "ખોટી સૂચનો,",
    "INCORRECT_INTENT": "ખોટો ઈરાદો,",
    "ACCIDENTAL_CLICK": "આકસ્મિક ક્લિક,",
    "TIME_TAKING": "સમય લે છે,",
    "OTHER": "અન્ય,",
    "PLAYBOOK_EMPTY_MSG": "પ્લેબુક પસંદ કરો,",
    "PLAYBOOK_EMPTY_DESC": "બધા ઉપલબ્ધ પ્લેબુક ડાયનામિક હોવાના કારણે એજન્ટ એઆઇ પ્લેબુક લોડ કરવામાં અસમર્થ છે. પ્લેબુકનો ઍક્સેસ મેળવવા માટે 'પ્લેબુક પસંદ કરો' પર ક્લિક કરો,",
    "STAGE": "સપાટો,",
    "PROCEED_TO_CLOSE": "બંધ કરવા માટે આગળ વધો,",
    "RECOMENDED_PLAYBOOK": "સૂચવેલ પ્લેબુક,",
    "PRIMARY_SCRIPTS": "પ્રાથમિક સ્ક્રિપ્ટ્સ,",
    "DYNAMIC_SCRIPTS": "ડાયનામિક સ્ક્રિપ્ટ્સ,",
    "RESUME": "પુનરારંભ,",
    "ENABLE_CLOSE": "બંધ કરવા માટે સુવિધા સક્રિય કરવા માટે આગળ વધો બટન પર ક્લિક કરો,",
    "LIST_VIEW": "યાદી દૃશ્ય,",
    "TERMINATE": "સમાપ્ત કરો,",
    "MINIMIZE": "ન્યૂનતમ કરો,",
    "MAXIMIZE": "વધારો,",
    "NO_SEARCH_RESULT": "કોઈ શોધ પરિણામ મળ્યું નથી,",
    "SENTIMENT_AWAITING": "ભાવના માટે રાહ જોવાઈ રહી છે,",
    "POSITIVE": "સકારાત્મક,",
    "NEGATIVE": "નકારાત્મક,",
    "ASSOCIATED_WORK_NOTES": "ભૂતકાળના સમાધાન નોંધ,",
    "AGENT_JOINED_CONV": "એજન્ટ વાતચીતમાં જોડાયું,",
    "AUTOSCROLL_ASSIST": "ઓટો-સ્ક્રોલ સહાય ટેબ સામગ્રી,",
    "FILE_SIZE_MSG": "ફાઇલનું કદ 25MBની અંદર હોવું જોઈએ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    "OVERRIDE_BTN": "ઓવરરાઇડ,",
    "CHOOSE_FILE": "ફાઇલ પસંદ કરો,",
    "SUMMARY_ERROR_TEXT": "અમને ખેદ છે, પરંતુ આ વાતચીત માટે સારાંશ ઉત્પન્ન કરવામાં એક સમસ્યા હતી. કૃપા કરીને તમારું પોતાનું સારાંશ બનાવો.",
    "ASK_A_QUESTION": "પ્રશ્ન પૂછો",
    "COPY" : "નકલ",
    "TELL_US_MORE": "વધુ કહો",
    "THANKS_FEEDBACK": "તમારા પ્રતિસાદ માટે આભાર",
    "SOMETHING_WRONG": "કેટલાકને ખોટું થયું છે",
    "CLICK_ERROR_DETAILS": "ત્રુટિ વિગતો માટે ક્લિક કરો",
    "NO_ACTIVE_PLAYBOOK": "કોઈ સક્રિય પ્લેબુક નથી",
    "REPHRASE_QUESTION": "શું તમે તમારા પ્રશ્નને પુનરાગમન કરી શકો છો અથવા બીજું કંઈ પૂછો?",
    "INTERNAL_INFO": "આંતરિક માહિતી",
    "SOURCES": "મૂળ",
    "CONVERSATION_SUMMARY": "સંવાદનો સારાંશ",
    "WAITING": "પ્રતીક્ષા કરી રહ્યા છે",
    "WIDGET_DISABLED": "વિજેટ નિષ્ક્રિય કરવામાં આવ્યું છે",
    "AI_SETTINGS_DISABLED": "એ.આઈ. સુયોજનો નિષ્ક્રિય છે! કૃપા કરીને એ.આઈ. પ્રમુખ સાથે સંપર્ક કરો",
    "SERVER_CONNECTION_ERROR": "સર્વરમાં કનેક્શન કરતી વખતે ભૂલ",
    "VIEW": "જુઓ",
    "ATTACHMENT_INPUT": "જોડાણ ઇનપુટ",
    "TYPE_SUMMARY": "સારાંશ ટાઇપ કરો",
    "VIEW_FULL_ARTICLE_2": "સંપૂર્ણ લેખ જુઓ",
    "VIEW_FULL_FILE_2": "સંપૂર્ણ ફાઇલ જુઓ",
    "BY":"દ્વારા",
    GENERATE_SUMMARY: "સારાંશ બનાવો",
    PREV_SUMMARIES: "પહેલા બનાવેલા સારાંશ",
    DIALOG_WORKFLOWS: "ડાયલોગ વર્કફ્લો",
    SHOW_ALL_DIALOG: "બધા ડાયલોગ ટાસ્ક બતાવો",
    SHOW_ALL_DIALOGS: "બધા ડાયલોગ બતાવો",
    CUSTOM_TAB: "કસ્ટમ ટેબ",
    AGENT_INPUT: "એજન્ટની ઇનપુટ",
    "CUSTOM_EMPTY_MSG" : "કોઈ સક્રિય વર્કફ્લો હવે છે",
    "CUSTOM_TAB_DESC" : "વર્કફ્લો શરૂ કરવા માટે, સ્ક્રીનના નીચે ઉપલબ્ધ વર્કફ્લોમાંથી એક ચાલાવો.",
    "SUBMIT_OVERALL_FEEDBACK" : "સમગ્ર પ્રતિક્રિયા જમા કરો",
    "FEEDBACK_POPUP_SUBTITLE" : "વિજેટ અને તેના વિશેષતાઓ માટે તમે કેવી રીતે આનંદ લોવાની છો?",
    "FEEDBACK_SATISFIED" : "આનંદપૂર્ણ",
    "FEEDBACK_UNSATISFIED" : "આનંદપૂર્ણ નથી",
    "FEEDBACK_PROVIDE_REASONS" : "વધુ માહિતી આપો…",
    "FEEDBACK_TITLE" : "પ્રતિક્રિયા",
    "AGENTIC_THINKING" : "વિચારી રહ્યું છે",
    "AGENTIC_AGENT_TITLE" : "એજન્ટ",
    "AGENTIC_COPILOT_MODE_TITLE" : "એજન્ટિક કોપિલોટ મોડ",
    "AGENTIC_SENDING_MESSAGE" : "મોકલી રહ્યું છે...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot તમારી વાતચીતને સક્રિય રીતે સાંભળી રહ્યું છે અને આપમેળે સહાય કરવા માટે તૈયાર છે",
    "AGENTIC_SEARCH_RESULTS" : "એજન્ટ પરિણામો",
    "PAUSE_AUTO_SEND" : "સ્વચાલિત મોકલવાનું થોભાવો",
    "PAUSE_AGENTIC" : "એજન્ટ થોભાવો",
    "RESUME_AGENTIC" : "એજન્ટ ફરીથી શરૂ કરો",
    "RESUME_AUTO_SEND" : "સ્વચાલિત મોકલવાનું ફરીથી શરૂ કરો"
}